export const LINE_OA = "https://lin.ee/FmzHNHZ"
export const FACEBOOK = "https://www.facebook.com/profile.php?id=61566562891979"
export const TIKTOK = "https://www.tiktok.com/@dofarm_th?_t=8oaJ6mFgP4B&_r=1"
export const YOUTUBE = "https://www.youtube.com/@dofarm-th"